import { render } from "./SubscriptionPlanUpgrader.vue?vue&type=template&id=20054a94"
import script from "./SubscriptionPlanUpgrader.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanUpgrader.vue?vue&type=script&lang=js"

import "./SubscriptionPlanUpgrader.vue?vue&type=style&index=0&id=20054a94&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__